import React, {useEffect, useState } from 'react';

import Typography from '@material-ui/core/Typography';

import CircularProgress from '@material-ui/core/CircularProgress';

import { numberFormat } from '../../helper/MaskHelper';

import ContadorService from '../../services/Contador';

const Contador = () => {
    const [ contador, setContador ] = useState();
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {    
        ContadorService.getDadosContagem()
            .then(res => {
                setContador(res.data);
                setLoading(false);
            })        
    }, []);

    return (
        <Typography variant="body2" align="center">
            Acessos a este sítio: &nbsp;
            { loading ? 
                <CircularProgress style={{ marginLeft: '7px' }} color="secondary" size={12} /> 
            : 
                <>
                    <b>{contador.visitas ? numberFormat(contador.visitas) : 'XXXXXX'}</b> &nbsp;
                    <span style={{ fontSize: 10 }}>(desde <b>{contador.inicio ?? 'XX/XX/XXXX'}</b>)</span>
                </> 
            }
        </Typography>
    );
}

export default Contador;